import { Controller } from 'stimulus';
import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

export default class extends Controller {
  static targets = ['slider', 'overlay', 'prev', 'next']

  connect() {
    this.initHeroSliderIfRequired();
  }

  initHeroSliderIfRequired() {
    if (this.element.getAttribute("data-enable-carousel") === "true" && this.sliderTarget) {
      new Swiper(this.sliderTarget, {
        slidesPerView: 1,
        loop: true,
        speed: 600,
        allowTouchMove: false,
        navigation: {
          prevEl: this.prevTarget,
          nextEl: this.nextTarget,
        },
      });
    }
    this.checkImagesLoaded();
  }

  checkImagesLoaded() {
    const firstImage = this.sliderTarget.querySelector('img');
    if (firstImage.complete && firstImage.naturalHeight !== 0) {
      this.fadeOutOverlay();
      return;
    }

    firstImage.addEventListener('load', () => this.fadeOutOverlay(), { once: true });
  }

  fadeOutOverlay() {
    this.overlayTarget.classList.add('dining-hero__overlay--faded');
  }
}
